<template>
  <div class="mx-3 d-flex">
    <div
      class="mr-5"
      no-gutters
      v-for="(menu, index) in getNavMenusByPermission"
      :key="menu.title"
    >
      <v-btn
        tile
        class="main-menu px-0 mb-0"
        :class="getClass(menu)"
        text
        :ripple="false"
        :to="menu.link"
        @click="() => menu.onTabClick && menu.onTabClick(menu, index)"
        :data-test-id="menu.meta && menu.meta.id"
      >
        {{ menu.title }}
      </v-btn>
      <v-icon
        @click="() => menu.clickHandler(menu, index)"
        v-if="menu.closable"
        x-small
        class="ml-2"
        >close</v-icon
      >
    </div>
    <!-- <v-spacer></v-spacer>
    <v-btn
      text
      :ripple="false"
      color="#58e2c2"
      large
      :href="portalLink"
      class="addOrganisation pa-0 ma-0"
      >Return to portal</v-btn
    > -->
  </div>
</template>
<script>
import EventBus from '@/EventBus';
import { mapState } from 'vuex';
export default {
  props: ['title', 'additionalChildren'],
  data() {
    return {
      menuData: []
    };
  },
  computed: {
    ...mapState(['globalNav']),
    getNavMenusByPermission() {
      // PLEASE IGNORE IT FOR NOW
      let validMenus = [];

      this.menuData.forEach(menu => {
        if (menu.title === 'Vault') {
          const canShowVault = this.connectorArchiveNameMap(
            null,
            'consentMenu'
          );
          if (canShowVault.length) {
            const orgConnectors = this.connectorArchiveNameMap(
              null,
              'consentMenu',
              'currentOrgActiveConnectors'
            );
            if (orgConnectors[0]?.link) {
              menu.link = orgConnectors[0].link;
            }
            validMenus.push(menu);
          }
        } else if (menu.permission === undefined) {
          // no permission needed for these menus
          validMenus.push(menu);
        } else {
          if (this.checkPermissions(menu.permission, menu.meta?.validateSomePermissions)) {
            validMenus.push(menu);
          }
        }
      });

      return [...validMenus, ...(this.additionalChildren || [])];
    }
  },
  mounted() {
    let userData = JSON.parse(localStorage.getItem('userData'));

    if (userData) {
      this.getUser();
    } else {
      EventBus.$on('userMounted', this.getUser);
    }
  },
  watch: {
    globalNav() {
      this.getUser();
    }
  },
  methods: {
    getClass(item) {
      if (item.active) {
        return 'v-btn--active';
      }
      if (!this.$route.meta) {
        return;
      }

      return this.$route?.meta.subNav?.toLowerCase() ===
        item?.title?.toLowerCase()
        ? 'v-btn--active'
        : '';
    },
    getUser() {
      this.subMenuSelect(this.title);
    },

    subMenuSelect(val) {
      const subMenudata = this.globalNav;
      subMenudata.forEach(element => {
        if (element.parent === val) {
          this.menuData = element.children;
        }
      });
    }
  }
};
</script>
